import { useEffect, useState } from "react";
import {
  useOrderSettings,
  usePosOrderSettings,
} from "../../../services/Pos/usePosOrderSettings";
import useProfileDashboard from "../../../services/Settings/useProfileDashboard";
import useOrderSetting from "../../../services/Order/useOrderSetting";
import DeliveryChargesTab from "./DeliveryChargesTab";
import DiscountTab from "./DiscountTab";
import CustomizationTab from "./CustomizationTab";
import PaymentMethodTab from "./PaymentMethodTab";
import ReceiptPrintingTab from "./ReceiptPrintingTab";
import LoadingScreen from "../../../utils/LoadingScreen";
import Integration from "./integrations/Integration";

export default function PosOrderSettings() {
  const tabs = [
    "Delivery Charges",
    "Discounts",
    "Customization",
    "Payment Method",
    "Receipt Printing",
    "Pos Settings",
  ];

  const [activeTab, setActiveTab] = useState("Delivery Charges");

  const {
    loading,
    discountsList,
    printSettingDetails,
    getDiscounts,
    updatePosDiscount,
    deleteDiscount,
    updatePrintSettings,
    deliveryCharges,
    getPosDeliveryCharges,
    customizations,
    getCustomizations,
    addCustomization,
    deleteCustomization,
    addPaymentMethod,
    deletePaymentMethod,
  } = usePosOrderSettings();

  const { deleteDeliveryCharges } = useOrderSetting();

  const { fetchReceiptDetails } = useProfileDashboard();

  const [paymentMethods, setPaymentMethods] = useState([]);
  const [paymentMethodInput, setPaymentMethodInput] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [tabLoading, setTabLoading] = useState(false);

  const loadPaymentMethods = async () => {
    try {
      setTabLoading(true);

      const res = await fetchReceiptDetails();

      console.log("Payment Method Response:", res);

      setPaymentMethods(res?.paymentMethods || []);
    } catch (error) {
      console.error("Payment methods load error:", error);
      setPaymentMethods([]);
    } finally {
      setTabLoading(false);
    }
  };

  const handleTabChange = async (tab) => {
    setActiveTab(tab);

    if (tab === "Delivery Charges") {
      await getPosDeliveryCharges();
    }

    if (tab === "Discounts") {
      getDiscounts();
    }

    if (tab === "Customization") {
      await getCustomizations();
    }

    if (tab === "Payment Method") {
      await loadPaymentMethods();
    }

    if (tab === "Receipt Printing") {
      setTabLoading(true);
      setTabLoading(false);
    }
  };

  const handleAddPaymentMethod = async () => {
    if (!paymentMethodInput.trim()) return;

    const res = await addPaymentMethod(paymentMethodInput);

    if (res?.responseCode === "00") {
      setPaymentMethodInput("");
      loadPaymentMethods();
    }
  };

  const handleConfirmDelete = async () => {
    if (!selectedItem) return;

    const res = await deletePaymentMethod(selectedItem.id);

    if (res?.responseCode === "00") {
      setShowModal(false);
      setSelectedItem(null);
      loadPaymentMethods();
    }
  };

  useEffect(() => {
    getPosDeliveryCharges();
  }, []);

  return (
    <>

      <div className="p-6 h-full flex flex-col overflow-hidden montserrat-font-1">
        <div className="sticky top-0 z-30 pb-4">
          {/* Header */}
          <h1 className="text-xl font-semibold mb-4">POS Order Settings</h1>

          {/* Tabs (UPDATED STYLE) */}
          <div className="flex gap-8 border-b border-gray-200 mb-6 montserrat-font-1 overflow-x-auto">
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => handleTabChange(tab)}
                className={`pb-3 text-sm font-medium whitespace-nowrap transition-colors ${
                  activeTab === tab
                    ? "text-green-600 border-b-2 border-green-600"
                    : "text-gray-500 hover:text-gray-700"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>
        <div className="flex-1 overflow-y-auto min-h-0 pt-4">
          {(loading || tabLoading) && (
            <div className="flex justify-center py-6">
              <LoadingScreen text="Updating....." />
            </div>
          )}

          {/* Tab Content */}
          {activeTab === "Delivery Charges" && (
            <DeliveryChargesTab
              data={deliveryCharges}
              onDelete={deleteDeliveryCharges}
            />
          )}

          {activeTab === "Discounts" && (
            <DiscountTab
              data={discountsList}
              onDelete={deleteDiscount}
              onUpdate={updatePosDiscount}
            />
          )}

          {activeTab === "Customization" && (
            <CustomizationTab
              data={customizations}
              getCustomizations={getCustomizations}
              addCustomization={addCustomization}
              deleteCustomization={deleteCustomization}
            />
          )}

          {activeTab === "Payment Method" && (
            <PaymentMethodTab
              paymentMethods={paymentMethods}
              paymentMethodInput={paymentMethodInput}
              setPaymentMethodInput={setPaymentMethodInput}
              handleAddPaymentMethod={handleAddPaymentMethod}
              showModal={showModal}
              setShowModal={setShowModal}
              selectedItem={selectedItem}
              setSelectedItem={setSelectedItem}
              handleConfirmDelete={handleConfirmDelete}
            />
          )}

          {activeTab === "Receipt Printing" && (
            <ReceiptPrintingTab onLoadingChange={setTabLoading} />
          )}

          {activeTab === "Pos Settings" && <Integration />}
        </div>
      </div>
    </>
  );
}
